import Vue from 'vue'
import Select2 from 'v-select2-component'
import DateRangePicker from 'vue2-daterange-picker'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Select2MultipleControl from 'v-select2-multiple-component'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Default from '../layout/Wrappers/defaultLayout.vue'
import Login from '../layout/Wrappers/loginLayout.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import { GOOGLE_API_TOKEN } from '@/.env'
import VueLoadingOverlay from 'vue-loading-overlay'
import NotiSuccess from '@/components/Modal/Noti-Success.vue'
import NotiError from '@/components/Modal/Noti-Error.vue'
import Multiselect from 'vue-multiselect'
import AddImages from '@/components/Modal/Add-Images.vue'
import DraggableTable from '@/components/draggable-table'
import DateTimePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import VCalendar from 'v-calendar';
import Card from '@/components/common/Card.vue'
import Content from '@/components/common/Content.vue'
import Status from '@/components/common/Status.vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VCalendar)

Vue.component('DraggableTable', DraggableTable)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('Select2', Select2)
Vue.component('DateRanger', DateRangePicker)
Vue.component('Datepicker', Datepicker)
Vue.component('Select2MultipleControl', Select2MultipleControl)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('DateRangePicker', DateRangePicker)
Vue.component('VueLoadingOverlay', VueLoadingOverlay)
Vue.component('NotiSuccess', NotiSuccess)
Vue.component('NotiError', NotiError)
Vue.component('AddImages', AddImages)
Vue.component('default-layout', Default)
Vue.component('login-layout', Login)
Vue.component('multiselect', Multiselect)
Vue.component('DateTimePicker', DateTimePicker)
Vue.component('Card', Card)
Vue.component('Content', Content)
Vue.component('Status', Status)

Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_API_TOKEN,
    libraries: 'places'
  }
})
